export default {
  methods: {
    initValuesFromDom() {

      ;[].forEach.call( this.$el.elements, input => {
        if (input.name in this) {
          if (input.selectedIndex) { // select
            this[input.name] = input.options[input.selectedIndex].value
          } else { // input
            this[input.name] = input.value
          }
        }
      } )

    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/initValuesFromDom.js